// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_fz","galleryItem_borderTopRadius":"c-q_fA","galleryItem__image":"c-q_fB"};